export default "__VITE_ASSET__f8c7954b__"